// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Currency = t.struct({
    currency: t.String,
    value: t.Number
}, {
    name: 'Currency',
    strict: true
});

export const getDefaultState = () => new Currency({
    currency: '',
    value: 0
});

export default Currency;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/currency.js